import { serializeSlate } from '@securecore-new-application/securecore-parser';

export const parseSlateToHtml = (data: unknown) => {
  return serializeSlate(data);
};
